import { Box, Typography } from '@mui/material';
import './index.scss';

interface PageStatsProps {
  total: number;
  filtered?: number;
  label?: string;
}

const PageStats: React.FC<PageStatsProps> = ({ total, filtered, label = 'records' }) => {
  const isFiltered = filtered !== undefined && filtered !== total;

  return (
    <Box className="page-stats-bar">
      <Typography className="page-stats-text">
        <span className="page-stats-count">{total.toLocaleString()}</span> {label}
        {isFiltered && (
          <>
            <span className="page-stats-arrow"> → </span>
            <span className="page-stats-count filtered">{filtered!.toLocaleString()}</span> filtered
          </>
        )}
      </Typography>
    </Box>
  );
};

export default PageStats;
